<template>
  <div>
    <svg  class="ligneSvg" >
      <g v-for="vente in ventes" :key="vente.key" @click="clickCase(vente)" class="pointer">
        <title>{{ vente.annonceurComplet }} {{ calDate(vente) }}</title>
        <rect
          :x="vente.x1String" y="4%" :width="vente.widthString"
          rx="2" ry="2" height="92%"
          :stroke="vente.stroke" stroke-width="2" :fill="vente.fill"/>
        <rect v-if="vente.widthBlocage > 0"
          :x="vente.x1String" y="4%"
          :width="vente.widthBlocageString" rx="2" ry="2" height="92%"
          stroke-width="0" :fill="vente.colorOccupation"/>
        <text v-if="vente.annonceur"
          :x="vente.x1String" y="50%" dominant-baseline="central" text-anchor="start"
          font-size="12" :fill="vente.textColor">&#xA0;{{ vente.annonceur }}</text>
        <text
          :x="vente.x2String" y="50%" dominant-baseline="central" text-anchor="end"
          font-size="12" :fill="vente.textColor">{{ vente.endString }}&#xA0;</text>
        <g v-if="vente.checked">
          <circle
            v-if="vente.option === typesOptions.SELECTION"
            :cx="vente.xmilieuString"
            cy="50%"
            r="8"
            fill="#78D77C"/>
          <circle
            v-if="vente.option === typesOptions.BLOQUE"
            :cx="vente.xmilieuString"
            cy="50%"
            r="8"
            fill="#FE7979"
            stroke="#303E4E"/>
          <circle
            v-if="vente.option === typesOptions.OPTION"
            :cx="vente.xmilieuString"
            cy="50%"
            r="8"
            fill="#FFEA76"
            stroke="#303E4E"/>
          <text
            v-if="vente.option === typesOptions.SELECTION"
            :x="vente.xmilieuString" y="50%"
            dominant-baseline="central" text-anchor="middle"
            font-size="10" font-weight="bold" fill="white">&#10003;</text>
        </g>
      </g>
    </svg>
    <b-modal
      v-model="isComponentOuvrirListeFaces"
      has-modal-card
      class="modal modal-liste-faces"
      width="80vw">
      <Consultation
        :reseau="copieReseauTemporaire"
        :no-update="true"
        :date-debut="infoDate.debut"
        :date-fin="infoDate.fin"
        :semaine="infoDate.semaine"
        :affectations="affectations"
        :show-affectations="true"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import decorateurRectangleReseauxTempo from '@/services/decorateur/decorateurRectangleReseauxTempo';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import * as typesOptions from '@/configuration/optionConf';
import getFacesReseauAsync from '@/services/reseauxTempo/getFaces';
import { CLASS_NIVEAU_DISPONIBILITE } from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import customArraySort from '@/services/general/customArraySort';
import Consultation from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import { JOUR_DEBUT_SEMAINE } from '@/configuration/datePickerConf';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Panier = createNamespacedHelpers('panier');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  props: ['data', 'index'],
  components: {
    Consultation,
  },
  data() {
    return {
      isComponentOuvrirListeFaces: false,
      copieReseauTemporaire: {},
      typesOptions,
      infoDate: {},
      affectations: [],
    };
  },
  computed: {
    ...VenteReseauxTempo.mapGetters([
      'criterePlanning',
      'dataPropositions',
      'poseOption',
    ]),
    ...Panier.mapGetters([
      'reseauxTempoPanier',
    ]),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    ventes() {
      if (!Object.prototype.hasOwnProperty.call(this.dataPropositions, this.data.num)) {
        return [];
      }
      // TODO Revoir la méthode pour s'appuyer sur une version générique de
      // getRectangle gérant juste l'affichage
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      let dateVar = dateStart.clone();
      while (dateVar < dateEnd) {
        const key = dateVar.isoWeekYear() + dateVar.isoWeek().toString().padStart(2, '0');
        if (!Object.prototype.hasOwnProperty.call(this.dataPropositions[this.data.num], key)) {
          dateVar = dateVar.add(7, 'days');
          // Ne devrait jamais arriver sauf si le réseau est neutralisé
          // Une case libre devrait avoir des données
          /* eslint-disable no-continue */
          continue;
          /* eslint-enable no-continue */
        }
        const casePlanning = this.dataPropositions[this.data.num][key];
        const result = getRectangle(this.criterePlanning,
          dateVar,
          dateVar.clone().add(6, 'days'));
        if (result) {
          decorateurRectangleReseauxTempo(result,
            this.criterePlanning.showAnnonceur,
            casePlanning,
            dateVar,
            this.reseauxTempoPanier,
            this.data);
          result.jourDeDepart = casePlanning.jourDeDepart;
          ventesArray.push(result);
        }
        dateVar = dateVar.add(7, 'days');
      }
      return ventesArray;
    },
  },
  methods: {
    ...VenteReseauxTempo.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteReseauxTempo.mapMutations({
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
    }),
    async clickCase(vente) {
      const key = getAnneeSemaine(vente.annee, vente.semaine);
      if (this.criterePlanning.modeConsultation) {
        this.affectations = this.dataPropositions[this.data.num][key].affectations;
        this.openConsultation(vente);
        return;
      }
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.$set(this.dataPropositions[this.data.num][key], 'checked', !vente.checked);
      this.$set(this.dataPropositions[this.data.num][key], 'option', this.poseOption);
      await this.actionsGestionPanier({
        resNum: this.data.num,
        semaine: vente.semaine,
        annee: vente.annee,
        dataPropositions: this.dataPropositions[this.data.num][key],
      });

      const reseauPanier = this.reseauxTempoPanier.find((el) => {
        return el.num === this.data.num;
      });
      this.setReseauxSelected({
        data: this.data.num,
        value: reseauPanier !== undefined && reseauPanier !== null,
      });
      loadingComponent.close();
    },
    async openConsultation(vente) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      const date = getDateByJourAnneeSemaine(this.data.jourDepart, vente.annee, vente.semaine);
      this.infoDate.debut = date.toDate();
      this.infoDate.fin = date.add(6, 'days').toDate();
      this.infoDate.semaine = vente.semaine;
      try {
        const query = {
          params: {
            dateVisualisation: date.format('YYYYMMDD'),
            anneeSemaine: getAnneeSemaine(vente.annee, vente.semaine),
            jourDepart: this.data.jourDepart,
            societeId: this.data.socCode,
            selectionFaceForOption: this.poseOption,
          },
        };
        const response = await getFacesReseauAsync(this.data.num, query);
        response.forEach((el) => {
          el.selected = false;
          el.dispoClass = CLASS_NIVEAU_DISPONIBILITE[el.dispo];
        });
        response.sort(customArraySort(['ville', 'panCode', 'facCode']));
        this.copieReseauTemporaire = Object.assign({}, this.data);
        this.copieReseauTemporaire.listeFaces = response;
        loadingComponent.close();
        this.isComponentOuvrirListeFaces = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur(`Erreur lors de la récupération des faces du réseau tempo n°${this.data.num}`, e);
        throw e;
      }
    },
    calDate(data) {
      if (!this.isAffixe2) {
        return getDateByJourAnneeSemaine(this.data.jourDepart + JOUR_DEBUT_SEMAINE, data.annee, data.semaine).format('DD/MM/YYYY');
      }
      // on fait -1 car getDateByJourAnneeSemaine fait +1
      return getDateByJourAnneeSemaine(data.jourDeDepart - 1, data.annee, data.semaine).format('DD/MM/YYYY');
    },
  },
};
</script>

<style>
  .ligneSvg{
    width:100%;
    height:34px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/planningTempoSvg.vue